export default {
  'outstanding.title': 'Outstanding',
  'outstanding.sectionTitle': 'Outstanding Report',
  'outstanding.sectionFilter.merchantName': 'Merchant Name',
  'outstanding.sectionFilter.search': 'Search by',
  'outstanding.sectionFilter.searchBtn': 'Search',
  'outstanding.sectionFilter.dueDays': 'Due by days',
  'outstanding.sectionFilter.sortBy': 'Sort by',
  'outstanding.sectionFilter.orderStatus': 'Order status',
  'outstanding.sectionFilter.exportToExcel': 'Export to Excel',
  'outstanding.menuTitle': 'Outstanding / collections',
  'outstanding.table.column.merchantID': 'Merchant ID',
  'outstanding.table.column.merchantName': 'Merchant Name',
  'outstanding.table.column.customerID': 'Customer ID',
  'outstanding.table.column.mobileNumber': 'Mobile Number',
  'outstanding.table.column.emailAddress': 'Email Address',
  'outstanding.table.column.orderId': 'Order ID',
  'outstanding.table.column.orderReference': 'Reference ID',
  'outstanding.table.column.orderDate': 'Order Date',
  'outstanding.table.column.orderStatus': 'Status',
  'outstanding.table.column.type': 'Type',
  'outstanding.table.column.orderAmount': 'Order Amount',
  'outstanding.table.column.installmentID': 'Installment ID',
  'outstanding.table.column.dueDate': 'Due Date',
  'outstanding.table.column.installmentAmount': 'Installment <br/>  Amount',
  'outstanding.column.installmentAmount': 'Installment Amount',
  'outstanding.table.column.latePaymentFee': 'Late Payment <br/>Fee with VAT',
  'outstanding.table.column.totalToBeCollected': 'Total to be collected',
  'outstanding.table.column.merchantOrderCode': 'Merchant order code',
  'outstanding.table.column.attempts': 'Number of attempts',
  'outstanding.cta.reverseLateFee': 'Reverse',
  'outstanding.cta.manuallyCharge': 'Charge',
  'outstanding.modal.cancel': 'Cancel',
  'outstanding.modal.feeReversalComment':
    'Please add any additional comments here',
};
